import React, {useEffect, useState} from 'react';
import {
    FormControl,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {client} from '../../dataProvider';

interface AutocompleteProps {
    value: any;
    onChange: Function;
    className?: string;
    selectedLabel?: string;
}

interface CustomAutocompleteProps extends AutocompleteProps{
    url: string;
    onChange: Function,
    label: string;
    defaultFilter?: any;
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({url, className, onChange, value, label, defaultFilter, selectedLabel}) => {
    const [options, setOptions] = useState<Array<{ id: string; label: string }>>([]);
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState('');
    useEffect(() => {
        setLoading(true);
        client(url, {
            method: 'GET', params: {
                page: 1,
                page_size: 100,
                search: query,
                ...defaultFilter
            }
        })
            .then((response) => {
                setOptions(response.results || response);
            })
            .catch((error) => {
                console.error(`Errore caricamento ${label}:`, error);
            })
            .finally(() => setLoading(false));
    }, [query]);
    const selectedOption = options.find(opt => String(opt.id) === String(value)) ||
        (value && selectedLabel ? {id: value, label: selectedLabel} : null);


    return (
        <FormControl variant="outlined" size="small" fullWidth className={className}>
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option.label || ''}
                getOptionSelected={(option, selected) => String(option.id) === String(selected.id)}
                value={selectedOption}
                onChange={(event, newValue) => {
                    onChange(newValue ? newValue.id : null);
                }}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onChange={(e) => setQuery(e.target.value)}
                        label={label}
                        variant="outlined"
                        size="small"
                    />
                )}
            />
        </FormControl>
    )
}


export const ProvinceAutocomplete: React.FC<AutocompleteProps> = ({
                                                                              value,
                                                                              onChange,
                                                                              className
                                                                          }) => {


    return (
        <CustomAutocomplete url={`autocomplete/province`} onChange={onChange} label={"Provincia"} value={value} className={className}/>
    );
};

export const RegionAutocomplete: React.FC<AutocompleteProps> = ({
                                                                          value,
                                                                          onChange,
                                                                          className
                                                                      }) => {
    return (
        <CustomAutocomplete url={'autocomplete/region'} onChange={onChange} label={"Regione"} value={value} className={className}/>
    );
};

export const ReceiverAutocomplete: React.FC<AutocompleteProps> = ({
                                                                          value,
                                                                          onChange,
                                                                          className,
                                                                          selectedLabel
                                                                      }) => {
    return (
        <CustomAutocomplete url={'autocomplete/subject'} defaultFilter={{"type": "receiver"}} onChange={onChange} label={"Destino"} value={value} selectedLabel={selectedLabel} className={className}/>
    );
};

export const ClientAutocomplete: React.FC<AutocompleteProps> = ({
                                                                          value,
                                                                          onChange,
                                                                          className
                                                                      }) => {
    return (
        <CustomAutocomplete url={'autocomplete/subject'} defaultFilter={{"type": "client"}} onChange={onChange} label={"Cliente"} value={value} className={className}/>
    );
};


export const WarehouseAutocomplete: React.FC<AutocompleteProps> = ({
                                                                                value,
                                                                                onChange,
                                                                                className
                                                                            }) => {

    return (
        <CustomAutocomplete url={'autocomplete/subject'} onChange={onChange} label={"Magazzino"} value={value} defaultFilter={{'type': "default_store"}} className={className}/>
    );
};
